import StripeGreenPattern from '@images/stripe-green.svg';
import { useGlobalContext } from '@context/customContext';

interface VoteProgressBarProps {
  winner?: boolean;
  draw?: boolean;
  title?: string;
  value: number;
  max: number;
}

const VoteProgressBar: React.FC<VoteProgressBarProps> = ({
  draw = false,
  winner = false,
  title,
  value,
  max,
}) => {
  const { themeData } = useGlobalContext();
  const styledShadow = {
    boxShadow: `-4px 7px ${themeData.colors['poll-questionCard-percentBox-shadow']}`,
  };
  return (
    <div className="flex flex-col py-4">
      {draw && (
        <h3 className="mb-2 text-lg text-poll-questionCard-progressBar-draw-color">
          TIE
        </h3>
      )}
      {winner && (
        <h3 className="mb-2 text-lg text-poll-questionCard-progressBar-winner-color">
          WINNER
        </h3>
      )}
      {title && (
        <h4 className="mb-2 text-lg text-poll-questionCard-progressBar-title-color">
          {title}
        </h4>
      )}
      <div className="h-12 border-poll-questionCard-progressBar-borderColor border-3 ">
        <div
          className="h-full bg-repeat"
          style={{
            width: `${((value / (max || 1)) * 100).toFixed(0)}%`,
            stroke: 'red',
            backgroundSize: 'cover',
            backgroundImage: `url(${StripeGreenPattern})`,
          }}
        />
      </div>
      <div className="flex">
        <div
          className="px-5 py-1 mb-2 ml-1 -mt-2 text-xl font-bold bg-poll-questionCard-percentBox-bgColor border-2 font-display text-poll-questionCard-percentBox-color border-poll-questionCard-percentBox-borderColor"
          style={styledShadow}
        >
          {((value / (max || 1)) * 100).toFixed(0)}%
        </div>
      </div>
      <div className="text-base font-bold text-poll-questionCard-numberVotes-color">
        {value} Votes
      </div>
    </div>
  );
};

export default VoteProgressBar;
